export const isProd = true;
export const ENDPOINT = isProd
  ? 'https://aligning.wassati.com/'
  : 'http://vps-5162c99b.vps.ovh.net:3003/';

//export const ENDPOINT = 'http://localhost:3003/';
//export const ENDPOINT = 'http://vps-5162c99b.vps.ovh.net:3003/';

export const featureAnticipatingEs = true;
